import { useState } from 'react';
import { resolveValidity, toPromise } from './validationSupport';

function useMultiValidator(initialValidity, fieldValidators, initialFieldValidity) {
    const initialState = {};
    const fields = Object.keys(fieldValidators);
    fields.forEach((field) => {
        if (initialFieldValidity && Object.prototype.hasOwnProperty.call(initialFieldValidity, field)) {
            initialState[field] = initialFieldValidity[field];
        } else {
            initialState[field] = initialValidity;
        }
    });

    const [validationsState, setValidationsState] = useState(initialState);
    const validators = {};
    for (let i in fields) {
        const field = fields[i];
        validators[field] = (input) => {
            const result = resolveValidity(fieldValidators[field], input, initialState[field]);
            setValidationsState((oldState) => ({ ...oldState, [field]: result}));
            return result;
        };
    }

    const isValid = () => toPromises(validationsState);
    return { validators, isValid };
}

function toPromises(validationResults) {
    return Promise.all(Object.values(validationResults).map((validationResult) => toPromise(validationResult)));
}

export default useMultiValidator;
